import React from 'react';
import { DrawerList } from '../../atoms';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';

const useStyles = makeStyles({
  list: {
    width: 220,
  },
  fullList: {
    width: 'auto',
  },
});

export default function SwipeableTemporaryDrawer({
  onClick = () => {
  },
  open,
  toggleDrawer = () => {
  },
}) {
  const classes = useStyles();

  return (
    <div>
      <Drawer
        anchor={'left'}
        open={open}
        onClose={() => toggleDrawer(false)}
        onOpen={() => toggleDrawer(true)}
      >
        <div
          className={clsx(classes.list)}
          role='presentation'
          onClick={() => toggleDrawer(false)}
          onKeyDown={() => toggleDrawer(false)}
        >
          <DrawerList onClick={onClick}/>
        </div>
      </Drawer>
    </div>
  );
}
